import { useEffect, useState } from "react"

// react-bootstrap imports
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import InputMask from "react-input-mask"

// custom hook
// import { registerFieldError } from "hooks/useGerarDocumento"

function GetField({ field, index })
{
    switch (field.type)
    {
        case "text":
        {
            const { name, placeholder, label, req, info, mask, maxTextLength, minWidth} = field
            return <TextInput Name={name + index} Placeholder={placeholder} Label={label} Type={"text"} Value={""} Req={req} Info={info} Mask={mask} MaxTextLength={maxTextLength} MinWidth={minWidth} key={name + index} />
        }
        case "dropdown":
        {
            const { name, itemsList, label, value, req} = field
            return <DropdownInput Name={name + index} ItemsList={itemsList} Label={label} Value={value} Req={req} key={name + index} />
        }
        case "textArea":
        {
            const { name, placeholder, label, numberLines, numberCols, req, info} = field
            return <TextAreaInput Name={name + index} Placeholder={placeholder} Label={label} NumberLines={numberLines} NumberCols={numberCols} Req={req} Info={info} key={name + index} />
        }
        case "number":
        {
            const { name, placeholder, label, value, onChange, req, info, min, max} = field
            return <NumberInput Name={name + index} Placeholder={placeholder} Label={label} Value={value} OnChange={onChange} Req={req} Info={info} Min={min} Max={max} key={name + index} />
        }
        default: return <></>
    }
}

function FormGroup(Name, Label, Field, Info, warnMsg, errorMsg, Req)
{
    return <Form.Group className="m-1" controlId={"Group" + Name} >
                <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
                {Field}
                <Form.Text className="text-muted">{Info}</Form.Text>
                {warnMsg ? <Form.Text className="text-warning my-0 fs-7">{warnMsg}</Form.Text> : <></>}
                {errorMsg ? <Form.Text className="text-danger my-0 fs-7">{errorMsg}</Form.Text> : <></>}
            </Form.Group>
}

function determineInputField(Type, name, itemsList, placeholder, label, fields, value, numberLines, numberCols, req, info, maxLength, min, mask, MinWidth, index)
{
    switch (Type)
    {
        case "listText": return <TextInput Name={name + index} Placeholder={placeholder} Label={label} Value={value} Req={req} Info={info} MinWidth={MinWidth} key={name + index} />
        case "listTextArea": return <TextAreaInput
                                        Name={name + index}
                                        Placeholder={placeholder}
                                        Label={label} Value={value ? value[index] : ""}
                                        NumberLines={numberLines}
                                        NumberCols={numberCols}
                                        Req={req}
                                        key={name + index}
                                        Info
                                    />
        case "listDropdown": return <DropdownInput Name={name + index} ItemsList={itemsList} Value={value + " " + (index + 1)} Req={req} key={name + index} />
        case "listGroupText": return <GroupInput Fields={fields} Index={index} key={name + index} />
        case "textArea": return <TextAreaInput Name={name + index} Placeholder={placeholder} Label={label} NumberLines={numberLines} NumberCols={numberCols} Req={req} Info={info} key={name + index} />
        default: console.log("Aviso: Tentando criar input em lista com tipo inválido. Type: " + Type) ; return
    }
}

export function GroupInput({ Fields, Index })
{
    if (!Fields) { console.log("Aviso: Tentando criar grupo de inputs com campos indefinidos") ; return }
    if (!Array.isArray(Fields)) { console.log("Aviso: Tentando criar grupo de inputs, mas Fields não é uma lista. Fields: " + Fields) ; return }

    return (
        <div className="d-flex">
            {Fields.map(field => <GetField field={field} index={Index} key={field.name + Index} />)}
        </div>
    )
}

export function SenhaInput({Name, Placeholder, Label, Value, Req, Info, OnChange, OnBlur, Warn, Errors})
{
    //const [errorMessage, setErrorMessage] = useState("")
    // const feedbackType = "invalid"
    // const errorMessage = ""
    
    // {
    //     errorMessage ?
    //     <Form.Text className="text-danger">{errorMessage}</Form.Text> :
    //     
    // }
    //{Errors !== undefined ? Errors.map(error => <div className="text-danger fs-7" key={error}>{error}</div>) : <></>}

    const Field = <Form.Control name={Name} placeholder={Placeholder} defaultValue={Value} type="password" required={Req} onChange={OnChange} onBlur={OnBlur}/>

    return FormGroup(Name, Label, Field, Info, undefined, undefined, Req)

    // return (
    //     <Form.Group className="m-1 position-relative" controlId={"validationFormik101"} >
    //         <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
    //         {Warn !== "" ? <p className="text-warning my-0 fs-7">{Warn}</p> : <></>}
    //         <Form.Control name={Name} placeholder={Placeholder} defaultValue={Value} type="password" required={Req} onChange={OnChange} onBlur={OnBlur}/>
    //         <Form.Text className="text-muted">{Info}</Form.Text>
    //         {Errors !== undefined ? <div className="text-danger fs-7">{Errors}</div> : <></>}
    //         <Form.Control.Feedback type={feedbackType} tooltip>{errorMessage}</Form.Control.Feedback>
    //     </Form.Group>
    // )
}

export function NumberInput({Name, Placeholder, Label, Value, OnChange, Req, Info, OnBlur, Min, Max, ValidationWarnings, ValidationErrors})
{
    const [warnMsg, setWarnMsg] = useState()
    const [errorMsg, setErrorMsg] = useState()

    function validate(event)
    {
        setErrorMsg(undefined)
        // registerFieldError(false)
        if (OnBlur)
        {
            OnBlur()
        }
        if (ValidationWarnings)
        {
            setWarnMsg(ValidationWarnings(event.target.value))
        }
        if (event.target.value < Min)
        {
            setErrorMsg(`Valor deve ser maior que ${Min}`)
            // registerFieldError(true)
            return
        }
        if (Max < event.target.value)
        {
            setErrorMsg(`Valor deve ser menor que ${Max}`)
            // registerFieldError(true)
            return
        }
        if (ValidationErrors)
        {
            setErrorMsg(ValidationErrors(event.target.value))
            // registerFieldError(!!ValidationErrors(event.target.value))
        }
    }

    // const [errorMessage, setErrorMessage] = useState("")
    const Field =
        <Form.Control
            name={Name}
            type={"number"}
            placeholder={Placeholder}
            defaultValue={Value}
            onChange={e => {if (OnChange !== undefined) { OnChange() } } }
            onWheel={e => e.target.blur()}
            step={0.01}
            required={Req}
            onBlur={(event) => {validate(event)}} 
        />

    return FormGroup(Name, Label, Field, Info, warnMsg, errorMsg, Req)

    // return (
    //     <Form.Group className="m-1" controlId={"Group" + Name} >
    //         <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
    //         {Warn !== "" ? <p className="text-warning my-0 fs-7">{Warn}</p> : <></>}
    //         {Field}
    //         <Form.Text className="text-muted">{Info}</Form.Text>
    //         {errorMessage !== undefined ? <div className="text-danger fs-7">{errorMessage}</div> : <></>}
    //     </Form.Group>
    // )
}

export function TextWithButtonInput({Name, Placeholder, Label, Value, OnChange, OnClick, ButtonText, ButtonImg, Req, Info, MaxTextLength, MinWidth, Mask, OnBlur})
{
    const [effectiveMask, setEffectiveMask] = useState(null)

    function updateMask(value) {setEffectiveMask(value ? Mask : null)}
    //const [errorMessage, setErrorMessage] = useState("")
    const errorMessage = ""

    const Field =
        Mask === null ?
        <Form.Control name={Name} type={"text"} placeholder={Placeholder} defaultValue={Value} className="" style={{minWidth: MinWidth}}
        onChange={e => { if (OnChange !== undefined) { OnChange() } } } maxLength={MaxTextLength} required={Req} /> :
        <InputMask name={Name} type={"text"} placeholder={Placeholder} mask={effectiveMask} maskChar=" " className="form-control"  style={{minWidth: MinWidth}}
        onChange={e => { updateMask(e.target.value) ; if (OnChange !== undefined) { OnChange() } } } onBlur={e => { if (OnBlur !== undefined) { OnBlur() } } } maxLength={MaxTextLength} required={Req} />

    return (
        <Form.Group className="m-1" controlId={"Group" + Name} >
            <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
            <div className="d-flex">
                {Field}
                <Button variant="outline-secondary" className="p-1" onClick={OnClick}>{ButtonText}{ButtonImg}</Button>
            </div>
            <Form.Text className="text-muted">{Info}</Form.Text>
            <Form.Control.Feedback type="invalid">{errorMessage}</Form.Control.Feedback>
        </Form.Group>
    )
}

// TODO substituir os textos com mask por esse
export function TextWithMaskInput({Name, Placeholder, Label, Value, OnChange, Req, Info, MaxTextLength, MinWidth, Mask, OnBlur, Error, Warn})
{
    // const [effectiveMask, setEffectiveMask] = useState(null)

    // function updateMask(value) {setEffectiveMask(value ? Mask : null)}
    // const defaultVal = Value === undefined? "" : Value
    return (
        <Form.Group className="m-1" controlId={"Group" + Name} >
            <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
            {Warn !== "" ? <p className="text-warning my-0 fs-7">{Warn}</p> : <></>}
            <Form.Control name={Name} type={"text"} placeholder={Placeholder} defaultValue={Value} className="" style={{minWidth: MinWidth}}
                        as={InputMask} mask={Mask}
                        onChange={OnChange} onBlur={OnBlur} maxLength={MaxTextLength} required={Req} />
            <Form.Text className="text-muted">{Info}</Form.Text>
            {Error !== undefined ? <div className="text-danger fs-7">{Error}</div> : <></>}
        </Form.Group>
    )
}

export function TextInput({Name, Placeholder, Label, Value, OnChange, Req, Info, MaxTextLength, MinWidth, Mask, OnBlur, ValidationWarnings, ValidationErrors})
{
    const [warnMsg, setWarnMsg] = useState()
    const [errorMsg, setErrorMsg] = useState()

    function validate(event)
    {
        if (OnBlur)
        {
            OnBlur()
        }
        if (ValidationWarnings)
        {
            setWarnMsg(ValidationWarnings(event.target.value))
        }
        if (ValidationErrors)
        {
            setErrorMsg(ValidationErrors(event.target.value))
            // registerFieldError(!!ValidationErrors(event.target.value))
        }
    }

    const Field =
        Mask === null || Mask === undefined ?
        <Form.Control name={Name} type={"text"} placeholder={Placeholder} defaultValue={Value ?? ""} style={{minWidth: MinWidth}}
                        onChange={OnChange} onBlur={(event) => {validate(event)}} maxLength={MaxTextLength} required={Req} /> :
        <Form.Control name={Name} type={"text"} placeholder={Placeholder} defaultValue={Value} style={{minWidth: MinWidth}}
                        onChange={OnChange} onBlur={(event) => {validate(event)}} maxLength={MaxTextLength} required={Req} as={InputMask} mask={Mask} />
    
    return FormGroup(Name, Label, Field, Info, warnMsg, errorMsg, Req)

    // return (
    //     <Form.Group className="m-1" controlId={"Group" + Name} >
    //         <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
    //         {Field}
    //         <Form.Text className="text-muted">{Info}</Form.Text>
    //         {warnMsg ? <Form.Text className="text-warning my-0 fs-7">{warnMsg}</Form.Text> : <></>}
    //         {errorMsg ? <Form.Text className="text-danger my-0 fs-7">{errorMsg}</Form.Text> : <></>}
    //     </Form.Group>
    // )
}

export function TextAreaInput({Name, Placeholder, Label, Value, NumberLines, NumberCols, Req, Info})
{
    let numTextLines = NumberLines // +1 é para compensar frases longas, que passam para a próxima linha
    if (Value?.split("\n"))
    {
        numTextLines = Value?.split("\n")?.length + 1
    }

    const Field = <Form.Control as="textarea" name={Name} defaultValue={Value} placeholder={Placeholder} rows={numTextLines} cols={NumberCols} />

    return FormGroup(Name, Label, Field, Info, undefined, undefined, Req)

    // return (
    //     <Form.Group className="m-1" controlId={"Group" + Name}>
    //         <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
    //         <Form.Control as="textarea" name={Name} defaultValue={Value} placeholder={Placeholder} rows={numTextLines} cols={NumberCols} />
    //         <Form.Text className="text-muted">{Info}</Form.Text>
    //     </Form.Group>
    // )
}

export function DateInput({Name, Label, Value, OnChange, Req, Info})
{

    const Field = <Form.Control name={Name} type={"date"} defaultValue={Value} onChange={e => { if (OnChange !== undefined) { OnChange() } } } required={Req} />

    return FormGroup(Name, Label, Field, Info, undefined, undefined, Req)

    // return (
    //     <Form.Group className="m-1" controlId={"Group" + Name} >
    //         <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label>
    //         <Form.Control name={Name} type={"date"} defaultValue={Value} onChange={e => { if (OnChange !== undefined) { OnChange() } } } required={Req} />
    //         <Form.Text className="text-muted">{Info}</Form.Text>
    //     </Form.Group>
    // )
}

export function DropdownInput({Name, ItemsList, Value, OnChange, Req, Label, MinWidth, OnBlur})
{
    if (ItemsList === undefined) { console.log("Aviso: Tentando criar dropdown sem nenhuma opção. Campo não será criado.") ; return <></>}

    return(
        <Form.Group className="m-1 d-inline-block">
            {Label !== undefined ? <Form.Label>{Req ? "*" : <></>}{Label}</Form.Label> : <></>}
            <Form.Select name={Name} className="px-2" onChange={OnChange} style={{minWidth: MinWidth}} onBlur={() => {if (OnBlur) { OnBlur() }}} >
                <option>{[Value]}</option>
                { ItemsList.map(item => <option value={item} key={item}>{item}</option>) }
            </Form.Select>
        </Form.Group>
    )
}

export function CheckboxInput({Name, Label, Req, OnChange})
{
    return(
        <Form.Check className="m-1"
            name={Name}
            type="Checkbox"
            label={Label}
            required={Req}
            onChange={OnChange}
        />
    )
}

export function Radio({Name, Label, Options, OnChange, Req})
{
    return(
        <Form.Group className="m-1" onChange={OnChange}>
            <p className="fw-bold">{Label}</p>
            {Options.map(op => <Form.Check id={"labelRadio" + op} name={Name} type="radio" value={op} label={op} key={op} required={Req}/>)}
        </Form.Group>
    )
}

export function Switch({Name, Checked, Label, OnChange, DefaultChecked})
{
    return (
        <Form.Check
            name={Name}
            type="switch"
            checked={Checked}
            label={Label}
            onChange={OnChange}
            defaultChecked={DefaultChecked}
        />
    )
}

export function ListInput({Type, name, itemsList, placeholder, label, fields, value, numberLines, numberCols, req, info, maxLength, min, mask, MinWidth, InitNumberItems})
{
    const initNumberItems = 0 < InitNumberItems ? InitNumberItems : 1
    const [inputFields, setInputFields] = useState(new Array(initNumberItems).fill("")) // esse valor inicial só é usado na 1a chamada. São 3 chamadas pra renderizar

    function removeItem(index)
    {
        let newInputFields = inputFields.slice()
        newInputFields.splice(index, 1)
        setInputFields(newInputFields)
    }

    function addItem()
    {
        let newInputFields = inputFields.slice()
        newInputFields.push(determineInputField(Type, name, itemsList, placeholder, label, fields, "", numberLines, numberCols, req, info, maxLength, min, mask, MinWidth, inputFields.length))
        setInputFields(newInputFields)
    }

    const MinusButton2 = ({ index }) => {return (
        <div>
            <Button className="btn btn-primary m-1" onClick={() => {removeItem(index)}}>Remover</Button>
        </div>
    )}

    const PlusButton = () => {return (
        <div>
            <Button className="btn btn-primary m-1" onClick={() => {addItem()}}>Adicionar</Button>
        </div>
    )}

    useEffect(() => {
        let newInputFields = []
        const array = new Array(initNumberItems).fill("")
        array.map((item, index) =>
            newInputFields.push(determineInputField(Type, name, itemsList, placeholder, label, fields, value, numberLines, numberCols, req, info, maxLength, min, mask, MinWidth, index))
        )
        setInputFields(newInputFields)
    }, [initNumberItems])

    return (
        <div className="d-flex">
            <div>
                {inputFields.map((input, index) => <div key={name + index}>{input}<MinusButton2 index={index} /></div>)}
                <PlusButton />
            </div>
        </div>
    )
}